module.exports = __webpack_public_path__ + "img/welcomelanding_icon2.ffbe19d1.png";